import CategoryPage, { getServerSideProps as s } from '../../category/[category-name]/index';

export default CategoryPage;
export const getServerSideProps = s;
